module.exports = __webpack_public_path__ + "static/media/communications3.0207abc3.png";